import { Injectable } from "@angular/core";
import { UserConfiguration } from "@app/core/user/domain/user-configuration";
import { languageToString } from "@app/presentation/utils/language-to-string-converter";
import { TranslateService } from "@ngx-translate/core";
import { GetUserConfigurationUseCase } from "@app/core/user/domain/use-cases/get-user-configuration.use-case";
import { Language } from "@app/core/user/domain/language";
import { catchError, firstValueFrom, map, of, tap } from "rxjs";

@Injectable({
    providedIn: 'root'
})

export class LanguageService {
    /**
   * Initialize localization.
   * @private
   */
  constructor(
    private translateService: TranslateService,
    private getUserConfigurationUseCase: GetUserConfigurationUseCase
  ){

  }
  public initializeLocalization(): Promise<void> {
    return firstValueFrom(
      this.getUserConfigurationUseCase.execute().pipe(
        tap((response) => {
          if (response != null) {
            this.setServiceLanguages(response.availableLanguages as Language[]);
          }
          this.setUserConfigurationLanguage(response);
        }),
        map(() => undefined),
        catchError(() => {
          this.setBrowserLanguage();
          return of(undefined);
        })
      )
    );
  }

  private setServiceLanguages(availableLanguages: Language[]): void {
    if (!Array.isArray(availableLanguages)) {
      console.error("availableLanguages is not an array:", availableLanguages);
      return;
    }
    const validLanguages = availableLanguages.filter(language => language !== undefined && language !== null);
    for (const language of validLanguages) {
      this.translateService.addLangs([languageToString(language)]);
    }
  }

  private setUserConfigurationLanguage(userConfiguration: UserConfiguration | null): void {
    if(userConfiguration && userConfiguration.language != null) {
      const hasLanguage = this.translateService.getLangs().includes(languageToString(userConfiguration.language));

      if (hasLanguage) {
        this.translateService.use(languageToString(userConfiguration.language));
        return;
      }
    }
    this.setBrowserLanguage();
  }

  private setBrowserLanguage(): void {
    const browserLanguage = this.translateService.getBrowserLang();
    if (browserLanguage === undefined) {
      return;
    }
    //Select the language of the browser
    this.translateService.use(browserLanguage);
  }
}
